import BaseService from './baseService';

class AccountService {

    static getUser() {
        return BaseService.getAndReturn('/Account/Me', BaseService.returnAssignedObject, 'Unable to get user', true);
    }

    //we only need to send the token if this is an additional login and we don't already have this token saved for the logged-in user
    static getUserInfo(token = null) {
        return BaseService.getAndReturn('/Account/UserInfo', BaseService.returnAssignedObject, 'Unable to get user info', true, null,  token ? {'Authorization': `Bearer ${token}`} : null)
    }

    static login(email, password) {
        return BaseService.postAndReturn('/Token', { username: email, password, grant_type: 'password' }, BaseService.returnAssignedObject, 'Unable to log in', true);
    }  

    static signup(email, password, firstName, surname, dob, gender, city, region, country, longitude, latitude) {
        return BaseService.postAndReturn('/Account/Signup', { email, password, firstName, surname, dob, gender, city, region, country, longitude, latitude }, BaseService.returnAssignedObject, 'Unable to sign up', true);
    }

    static getExternalLoginsList(returnUrl = '/Account/Login') {
        return BaseService.getAndReturn(`/Account/ExternalLoginsList?returnUrl=${returnUrl}&generateState=true&useCookies=true`, BaseService.returnAssignedArray, 'Unable to get external logins', true);
    }

    static registerExternal(email) {
        return BaseService.postAndReturn('/Account/RegisterExternal', { email }, BaseService.returnAssignedObject, 'Unable to register', true);
    }  

    static confirmEmail(email, code) {
        return BaseService.postAndReturn('/Account/ConfirmEmail', { email, code }, BaseService.returnAssignedObject, 'Unable to confirm email', true);
    }  

    static resendConfirmationEmail(email) {
        return BaseService.postAndReturn('/Account/ResendConfirmationEmail', { email }, (data) => data, 'Unable to resend confirmation email', true);
    }  

    static getExternalLogins() {
        return BaseService.getAndReturn('/Account/ExternalLogins', BaseService.returnAssignedArray, 'Unable to get external logins', true);
    }

    static changePassword(oldPassword, newPassword) {
        return BaseService.postAndReturn('/Account/ChangePassword', { oldPassword, newPassword }, BaseService.returnAssignedObject, 'Unable to change password', true);
    }  
    
    static setPassword(password) {
        return BaseService.postAndReturn('/Account/SetPassword', { password }, BaseService.returnAssignedObject, 'Unable to set password', true);
    }  

    static addLogin(externalAccessToken) {
        return BaseService.postAndReturn('/Account/AddExternalLogin', { externalAccessToken }, (data) => data, 'Unable to add login', true);
    }

    static removeLogin(loginProvider, providerKey) {
        return BaseService.postAndReturn('/Account/RemoveLogin', { loginProvider, providerKey }, (data) => data, 'Unable to remove login', true);
    }  

    static forgotPassword(email) {
        return BaseService.postAndReturn('/Account/ForgotPassword', { email }, (data) => data, 'Unable to send password reset', true);
    }  

    static resetPassword(email, code, password) {
        return BaseService.postAndReturn('/Account/ResetPassword', { email, code, password }, (data) => data, 'Unable to reset password', true);
    }  

    static getNotificationCount(roleID) {
        return BaseService.getAndReturn(`/Profiles/${roleID}/Notifications/Count`, BaseService.returnAssignedObject, 'Unable to fetch notification count', true);
    }

    static closeAccount(reason, removeFromMailingList) {
        return BaseService.postAndReturn('/Account/Close', { reason, removeFromMailingList }, (data) => data, 'Unable to close account', true);
    }  
}
export default AccountService;